import React, { useState } from "react";
import { PeriodSwitch } from "../PeriodSwitch";
import { PlanCard } from "../PlanCard";
import { calculatePriceForCard } from "../../../utils/calculatePriceForCard";
import {
  isDev,
  listOfSubscriptions,
  plansEnvConfig,
} from "../../../../../common/envConfig";

export const StudentFreePlans = ({ currentPlan, onGetStarted }) => {
  const [isMonthly, setIsMonthly] = useState(false);
  const [isAddonActive, setIsAddonActive] = useState({
    show3dPlayer: false,
    show3dPro: false,
  });

  return (
    <div>
      <PeriodSwitch
        isMonthly={isMonthly}
        onClick={() => setIsMonthly((prev) => !prev)}
      />

      <div className="flex flex-col md:flex-row gap-5 overflow-x-auto ">
        <PlanCard
          type="Basic"
          header="Free"
          subText="Get started with the basics"
          textList={[
            "5 swings per month",
            "1 goal recommended by Sportsbox",
            "Limited measurements related to your goal",
            "Review and analyze swings captured by a 3DGolf coach",
          ]}
          plan={[listOfSubscriptions.STUDENT_FREE]}
          currentPlan={currentPlan}
        />
        <PlanCard
          type="3D Player"
          header={calculatePriceForCard({
            monthlyPrice:
              plansEnvConfig[listOfSubscriptions.STUDENT_LITE_MONTHLY],
            annualPrice:
              plansEnvConfig[listOfSubscriptions.STUDENT_LITE_ANNUALLY],
            isAddonActive: isAddonActive.show3dPlayer,
          })}
          isMonthly={isMonthly}
          subText="Level up your lessons with 3D"
          textList={[
            "Unlimited swings",
            "Unlimited goals and customizable goals",
            "Basic tracker and indicator measurements",
            "Auto-swing detection",
            "2D and 3D comparison",
            "50+ practice drills with assessments",
          ]}
          plan={
            isMonthly
              ? [
                  listOfSubscriptions.STUDENT_LITE,

                  listOfSubscriptions.STUDENT_LITE_MONTHLY,
                ]
              : [listOfSubscriptions.STUDENT_LITE_ANNUALLY]
          }
          currentPlan={currentPlan}
          purchaseble
          onGetStarted={() =>
            onGetStarted(
              isMonthly
                ? listOfSubscriptions.STUDENT_LITE_MONTHLY
                : listOfSubscriptions.STUDENT_LITE_ANNUALLY,
              isAddonActive.show3dPlayer
            )
          }
          addonDetails={{
            show: true,
            state: isAddonActive.show3dPlayer,
            onChange: () =>
              setIsAddonActive((prev) => ({
                ...prev,
                show3dPlayer: !prev.show3dPlayer,
              })),
          }}
        />

        {isDev && (
          <PlanCard
            type="3D Player Plus"
            header={calculatePriceForCard({
              monthlyPrice:
                plansEnvConfig[listOfSubscriptions.PLAYER_PLUS_MONTHLY],
              annualPrice:
                plansEnvConfig[listOfSubscriptions.PLAYER_PLUS_ANNUALLY],
              isAddonActive: false,
            })}
            isMonthly={isMonthly}
            subText="Level up your lessons with 3D"
            textList={[
              "Everything on 3D Player, in addition to:",
              "All trackers and indicators available in Sportsbox AI app",
            ]}
            plan={
              isMonthly
                ? [listOfSubscriptions.PLAYER_PLUS_MONTHLY]
                : [listOfSubscriptions.PLAYER_PLUS_ANNUALLY]
            }
            currentPlan={currentPlan}
            purchaseble
            onGetStarted={() =>
              onGetStarted(
                isMonthly
                  ? listOfSubscriptions.PLAYER_PLUS_MONTHLY
                  : listOfSubscriptions.PLAYER_PLUS_ANNUALLY,
                false
              )
            }
          />
        )}
        <PlanCard
          type="3D Pro"
          header={calculatePriceForCard({
            monthlyPrice: plansEnvConfig[listOfSubscriptions.PREMIUM_MONTHLY],
            annualPrice: plansEnvConfig[listOfSubscriptions.PREMIUM_ANNUALLY],
            isAddonActive: isAddonActive.show3dPro,
          })}
          isMonthly={isMonthly}
          subText="Level up your lessons with 3D"
          textList={[
            "Unlimited students",
            "Unlimited swings",
            "All 2D and 3D analysis features",
            "All measurements",
            "Sportsbox drill library (50+ drills)",
            "2 devices per user",
          ]}
          plan={
            isMonthly
              ? [
                  listOfSubscriptions.LITE_MONTHLY,
                  listOfSubscriptions.PREMIUM,
                  listOfSubscriptions.PREMIUM_MONTHLY,
                ]
              : [
                  listOfSubscriptions.LITE_ANNUALLY,
                  listOfSubscriptions.PREMIUM_ANNUALLY,
                ]
          }
          currentPlan={currentPlan}
          purchaseble
          onGetStarted={() =>
            onGetStarted(
              isMonthly
                ? listOfSubscriptions.PREMIUM_MONTHLY
                : listOfSubscriptions.PREMIUM_ANNUALLY,
              isAddonActive.show3dPro
            )
          }
          addonDetails={{
            show: true,
            state: isAddonActive.show3dPro,
            onChange: () =>
              setIsAddonActive((prev) => ({
                ...prev,
                show3dPro: !prev.show3dPro,
              })),
          }}
        />
      </div>
    </div>
  );
};
